// extracted by mini-css-extract-plugin
module.exports = {"page":"SigninPage_page__Kwgby","main":"SigninPage_main___Pp0M"};